export default "__VITE_ASSET__CTP1n8Y7__"